"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var entity_1 = require("./entity");
function AssetsPostProcessor(response) {
    var _a;
    var assets = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.cards;
    if (assets && assets.length > 0) {
        var bx = assets.filter(function (x) { return x.propertyTypeId === entity_1.TabuPropertyType.VILLA_OR_BUILDING; });
        bx.forEach(function (b) {
            b.isVilla = b.propertySubTypeId === entity_1.TabuPropertySubType.VILLA;
        });
    }
    return Promise.resolve(response);
}
exports.AssetsPostProcessor = AssetsPostProcessor;
function SplitProxyProperties(response) {
    var _a;
    var assets = (_a = response === null || response === void 0 ? void 0 : response.response) === null || _a === void 0 ? void 0 : _a.cards;
    var xr = __assign({}, response);
    xr.response = {
        owned: [],
        companyProperties: [],
    };
    if (assets && assets.length > 0) {
        xr.response.owned = assets.filter(function (x) { return x.isAgent !== true; });
        var agentProps = assets.filter(function (x) { return x.isAgent === true; });
        var cp_1 = [];
        if (agentProps && agentProps.length > 0) {
            var pMap_1 = {};
            agentProps.forEach(function (ap) {
                var _a;
                var cId = (_a = ap.agentCompany) === null || _a === void 0 ? void 0 : _a.number;
                if (cId) {
                    var cps = pMap_1[cId + ""];
                    if (cps == null) {
                        cps = [];
                    }
                    cps.push(ap);
                    pMap_1[cId + ""] = cps;
                }
            });
            Object.values(pMap_1).forEach(function (x) {
                var _a, _b, _c, _d, _e;
                if (x && x.length > 0) {
                    var sample = x[0];
                    var px = {
                        properties: x,
                        id: (_a = sample.agentCompany) === null || _a === void 0 ? void 0 : _a.number,
                        name: {
                            ar: (_c = (_b = sample.agentCompany) === null || _b === void 0 ? void 0 : _b.name) === null || _c === void 0 ? void 0 : _c.arabicName,
                            en: (_e = (_d = sample.agentCompany) === null || _d === void 0 ? void 0 : _d.name) === null || _e === void 0 ? void 0 : _e.englishName,
                        }
                    };
                    cp_1.push(px);
                }
            });
        }
        xr.response.companyProperties = cp_1;
    }
    return Promise.resolve(xr);
}
exports.SplitProxyProperties = SplitProxyProperties;
